<template>
  <div class="page">
    <h2 class="title">STAI状态–特质焦虑问卷</h2>
    <div v-if="!showSubmit && question" class="question-card">
      <p class="question-text">{{ question.text }}</p>
      <div class="options">
        <button
          v-for="opt in question.options"
          :key="opt.value"
          class="option"
          :class="{ selected: selectedValue === opt.value }"
          @click="selectAnswer(opt.value)"
        >
  {{ opt.label }}
    </button>

      </div>
    </div>

    <!-- 测试完成页 -->
    <div v-else class="question-card">
      <p class="complete-title">测试完成</p>
      <div class="check-icon">✔️</div>
      <p class="complete-text">您已完成全部测试题目，可提交测试获取报告。</p>
      <button class="submit-btn" @click="submit">提交测试</button>
    </div>

    <!-- 底部按钮和进度条 -->
    <div class="footer">
      <button v-if="currentIndex > 0" class="prev-btn" @click="goBack">上一题</button>

      <div class="progress">
        <div class="bar"><div class="filled" :style="{ width: progressPercent + '%' }"></div></div>
        <div class="counter">{{ currentIndex + 1 }}/20</div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { TOKEN } from '@/utils/config';
export default {
    data () {
        return {
            token: '',
            questions: [],
            currentIndex: 0,
            answers: [],
            showSubmit: false
        };
    },
    computed: {
        question () {
            return this.questions[this.currentIndex];
        },
        isLastQuestion () {
            return this.currentIndex === this.questions.length - 1;
        },
        progressPercent () {
            return ((this.currentIndex + 1) / this.questions.length) * 100;
        },
        selectedValue () {
            return this.answers[this.currentIndex];
        }
    },
    async mounted () {
        let type = this.$route.query.type;
        if (type == 'test') {
            this.token = TOKEN;
        } else {
            let token = this.$route.query.token;
            this.token = token;
        }
    
        try {
            const res = await axios.get('/api/stai/questions?type=state', {
                headers: {
                    Authorization: 'bearer ' + this.token,
                    channel: 1000
                }
            });
    
            // 检查 HTTP 状态码
            if (res.status !== 200) {
                alert('请求失败，HTTP 状态码：' + res.status);
                return;
            }
    
            // 检查返回数据中的 success 字段
            if (!res.data.success) {
                alert(res.data.errors?.message || '未知错误');
                return;
            }
    
            // 如果成功，设置问题数据
            this.questions = res.data.result;
            this.answers = Array(this.questions.length).fill(null);
        } catch (err) {
            // 捕获网络错误并显示提示
            alert('加载问卷失败，请检查网络或稍后重试');
        }
    },
    methods: {
        selectAnswer (value) {
            this.answers[this.currentIndex] = value;
            if (this.isLastQuestion) {
                this.showSubmit = true;
            } else {
                this.currentIndex++;
            }
        },
        goBack () {
            if (this.showSubmit) {
                this.showSubmit = false;  // 留在当前题（即最后一题）
            } else if (this.currentIndex > 0) {
                this.currentIndex--;
            }
        },
        async submit () {
            try {
                const res = await axios.post('/api/stai/submit', {
                    user_id: Date.now().toString(),
                    state_answers: this.answers,
                    trait_answers: []
                }, {
                    headers: {
                        Authorization: 'bearer ' + this.token,
                        channel: 1000
                    }
                });

                if (res.status === 200 && res.data.success === true) {
                    this.$router.push('/appraisal/state-anxiety-result');
                } else {
                    alert('提交失败！');
                }
            } catch (err) {
                alert('提交失败，请检查网络或稍后重试');
            }
        }

    }
};
</script>

<style scoped>
.page {
  background: #f4f8fa;
  min-height: 100vh;
  padding: 20px;
}
.title {
  text-align: center;
  font-weight: bold;
}
.question-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  margin-top: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.question-text {
  font-size: 18px;
  margin-bottom: 20px;
}
.options {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.option {
  padding: 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: white;
}
.option:hover {
  background-color: #f0f0ff;
}
.option.selected {
  background-color: #e3d7ff;
  border-color: #8f5eff;
}
.check-icon {
  font-size: 40px;
  color: #05C2CB;
  text-align: center;
  margin-top: 12px;
}
.complete-title {
  color: #05C2CB;
  font-weight: bold;
}
.complete-text {
  text-align: center;
  margin: 12px 0;
}
.submit-btn {
  width: 100%;
  background-color: #05C2CB;
  color: white;
  padding: 12px;
  font-size: 16px;
  border-radius: 12px;
  border: none;
}
.footer {
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.prev-btn {
  background: white;
  padding: 10px 20px;
  border-radius: 12px;
  border: none;
  box-shadow: 0 1px 5px rgba(0,0,0,0.1);
}
.progress {
  width: 100%;
  max-width: 400px;
  margin-top: 16px;
  position: relative;
}
.bar {
  height: 6px;
  background: #ddd;
  border-radius: 3px;
}
.filled {
  height: 6px;
  background: #05C2CB;
  border-radius: 3px 0 0 3px;
}
.counter {
  text-align: right;
  font-size: 13px;
  color: #333;
  margin-top: 4px;
}
</style>
